import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { LogoEye } from "./LogoEye";
import { LogoInsight } from "./LogoInsight";

export function Logo(props: { height?: number; dark?: boolean; collapsed?: boolean }) {
  return (
    <Box
      component={Link}
      to="/"
      display="flex"
      flexDirection="row"
      alignItems="center"
      height={props.height}
      sx={{ textDecoration: "none", cursor: "default" }}
    >
      <LogoEye
        dark={props.dark}
        minWidth={30}
        maxWidth={56}
        mr={props.collapsed ? 0 : 0.5}
        height="100%"
      />

      {!props.collapsed && (
        <Box display="flex" flexDirection="row" alignItems="baseline">
          <LogoInsight dark={props.dark} width={80} sx={{ position: "relative", top: 4 }} />

          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              lineHeight: 1,
              ml: 0.5,
              position: "relative",
              top: 1,
              color: props.dark ? "common.white" : "text.secondary",
            }}
          >
            Labs
          </Typography>
        </Box>
      )}
    </Box>
  );
}
